function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "E4H/Catipliar");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\uD83D\\uDDA5-Wireframes-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: -1461,
  y: -2403,
  width: 4076,
  height: 2568
}), React.createElement("g", {
  id: "E4H/Catipliar",
  fill: "#739D63",
  fillOpacity: 0.5
}, React.createElement("g", {
  id: "Partner"
}, React.createElement("path", {
  d: "M0,10.3166638 C3.94581653,3.43888793 6.94581653,0 9,0 C11.0541835,0 14.0541835,3.43888793 18,10.3166638 C14.046875,16.7722213 11.046875,20 9,20 C6.953125,20 3.953125,16.7722213 0,10.3166638 Z"
})), React.createElement("g", {
  id: "Project",
  transform: "translate(9.000000, 0.000000)"
}, React.createElement("path", {
  d: "M0,10.3166638 C4.38424059,3.43888793 7.71757392,-1.8698493e-15 10,-1.8698493e-15 C12.2824261,-1.8698493e-15 15.6157594,3.43888793 20,10.3166638 C15.6076389,16.7722213 12.2743056,20 10,20 C7.72569444,20 4.39236111,16.7722213 0,10.3166638 Z"
})), React.createElement("g", {
  id: "Product",
  transform: "translate(20.000000, 0.000000)"
}, React.createElement("path", {
  d: "M0,10.3166638 C7.45320901,3.43888793 13.1198757,0 17,0 C20.8801243,0 26.546791,3.43888793 34,10.3166638 C26.5329861,16.7722213 20.8663194,20 17,20 C13.1336806,20 7.46701389,16.7722213 0,10.3166638 Z",
  id: "Prodcut"
}))));

var SvgCaterpillarSm = function SvgCaterpillarSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "54px",
    height: "20px",
    viewBox: "0 0 54 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaterpillarSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caterpillar_sm.67e690cd.svg";
export { ForwardRef as ReactComponent };